import { render, staticRenderFns } from "./ItemHistoryChangeTypePassword.vue?vue&type=template&id=5a5ce76a&scoped=true"
import script from "./ItemHistoryChangeTypePassword.vue?vue&type=script&lang=js"
export * from "./ItemHistoryChangeTypePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5ce76a",
  null
  
)

export default component.exports